try {
            require('./index.css');
          } catch (e) {
            if (e.code !== 'MODULE_NOT_FOUND') {
              throw e; // Re-throw unexpected errors
            }
            console.warn('index.css not found, proceeding without it.');
          }
          

import { jsx, jsxs } from 'react/jsx-runtime';
import { ErrorMessage } from '@design-system/error-message';
import { FieldHead } from '@design-system/field-head';
import { Icon } from '@design-system/icon';
import classNames from 'classnames';
import { useCallback } from 'react';
import Select, { components } from 'react-select';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const Dropdown = (_a) => {
    var { className, tooltipLabel, tooltipText, label, description, errorMessage, placeholder, options, onChange, isClearable, isDisabled, isMulti, value, id } = _a, rest = __rest(_a, ["className", "tooltipLabel", "tooltipText", "label", "description", "errorMessage", "placeholder", "options", "onChange", "isClearable", "isDisabled", "isMulti", "value", "id"]);
    const Option = useCallback((props) => {
        const { isSelected } = props;
        return (jsx("div", { children: jsxs(components.Option, Object.assign({}, props, { children: [props.label, isSelected ? (jsx(Icon, { size: 10, className: "cds-dropdown__selected-icon", icon: "checkmark" })) : null] })) }));
    }, []);
    return (jsxs("div", Object.assign({ className: classNames('cds-dropdown', className) }, { children: [jsx(FieldHead, { id: id, label: label, description: description, tooltipLabel: tooltipLabel, tooltipText: tooltipText }), jsx(Select, Object.assign({ components: { Option }, className: classNames('cds-dropdown__select', {
                    'cds-dropdown__select--error': Boolean(errorMessage),
                }), classNamePrefix: "cds-dropdown__select", styles: {
                    control: (_a) => {
                        var provided = __rest(_a, ["outline"]);
                        return provided;
                    },
                }, id: id, onChange: onChange, options: options, value: value, placeholder: placeholder || null, isClearable: isClearable, isDisabled: isDisabled, isMulti: isMulti, tabSelectsValue: false }, rest)), jsx(ErrorMessage, { message: errorMessage })] })));
};

export { Dropdown };
